<template>
    <div>
        <div id="address_list">
            <div class="address-item"
                v-for="(address, k) in addressList"
                :key="k">
                <div class="address-head">
                    <div class="address-no theme-txt">{{`${lbl.shipping.address_no}${k + 1}`}}</div>
                    <div class="address-action">
                        <div class="address-edit theme-txt"
                            v-if="page == 'profile'"
                            @click="clickEdit(address)">{{lbl.shipping.edit_address_btn}}</div>
                        <div class="address-delete"
                            v-if="page == 'profile'"
                            @click="clickDelete(address)">{{lbl.shipping.delete_address_btn}}</div>
                    </div>
                </div>
                <div class="address-info" @click="clickEdit(address)">
                    <div class="address-name">{{`${address.addressItem.firstname} ${address.addressItem.lastname}`}}</div>
                    <div class="address-desc">{{fullAddress(address.addressItem)}}</div>
                    <!-- <div class="address-tel">{{`${lbl.shipping.address_tel} ${telFormat(address.addressItem.contact_number)}`}}</div> -->
                    <div class="address-tel">{{`${lbl.shipping.address_tel} ${(address.addressItem.contact_number)}`}}</div>
                </div>
            </div>
        </div>
        <div id="add_address" class="btn-wrapper">
            <div class="btn-txt"
                @click="clickAdd">{{lbl.shipping.add_address_btn}}</div>
        </div>
    </div>
</template>
<script>
import Util from "@/helper/Utility.js";
export default {
    name: 'shipping-address-list',
    props: {
        lbl: Object,
        page: String,

        addressList: Array,

        busAddress: Object
    },
    data: function () {
        return {
        };
    },
    methods: {
        //event
        clickAdd: function () {
            this.busAddress.$emit('clickAdd');
        },
        clickEdit: function (address) {
            this.busAddress.$emit('clickEdit', {address: address});
        },
        clickDelete: function (address) {
            this.busAddress.$emit('clickDelete', {address: address});
        },
        //util
        fullAddress: function (address) {
            return `${address.address} ${this.lbl.shipping.subdistrict.name_shipping} ${address.subdistrict_name} ${this.lbl.shipping.district.name_shipping} ${address.district_name} ${this.lbl.shipping.province.name} ${address.province_name} ${address.zipcode}`;
        },
        telFormat: function (tel) {
            return Util.contactNumberFormat(tel, '-');
        }
    }
}
</script>
<style lang="scss" scoped>
@import "@/style/base/common.scss";
#address_list {
    .address-item {
        width: 100%;
        margin-bottom: 10px;
        padding: {
            left: 7px;
            right: 7px;
            bottom: 10px;
        }
        border-bottom: 1px solid #bfbfbf;

        font-size: 1.25rem;
        font-family: $regular;

        .address-head {
            @extend %display-flex;
            justify-content: space-between;

            .address-no {
                font-size: 1.75rem;
                font-family: $semi_bold;
            }

            .address-action {
                @extend %display-flex;
                width: 35%;
                flex: 0 0 35%;
                margin-top: auto;
                margin-left: auto;
                font-size: 1.4rem;
                font-family: $regular;
                text-align: right;

                .address-edit {
                    width: 50%;
                    flex: 0 0 50%;
                    text-decoration: underline;
                }

                .address-delete {
                    width: 50%;
                    flex: 0 0 50%;
                    color: $input-error-color;
                    text-decoration: underline;
                }
            }
        }

        .address-info {
            color: #333333;
            font-size: 1.4rem;
            line-height: 1.15;
            word-break: break-word;
        }
    }
}

#add_address {
    left: 0;
    right: 0;
    bottom: 20px;
    width: 100%;
    font-size: 1.3rem;
    font-family: $regular;
    text-align: center;
}
</style>
